import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {AngularJsMaterialModuleName, LoaderModuleName} from "../utils/names/requiredModulesNames";

export const LOADER_MODULE = new RestrictedRouteModuleConfiguration(
    LoaderModuleName,
    [
        AngularJsMaterialModuleName,
        LoaderModuleName
    ],
    [],
    [],
    [],
    []
);